export const environment = {
  inputCompiled: false,
  production: true,
  baseEndpoint: "https://api.chain4italy.it",
  websiteUrl: "https://tracking.chain4italy.it",
};
